export default __webpack_public_path__ + "static/iconoMujerHome-8d9a709a6df3f1c27dd90ce9f8522ecf.png";